import { _ } from "../../core/polyglot/polyglot.js";
import AccountGroup from "./AccountGroup.js";

/**
 * `undefinedAccountGroup` is an account group that's not defined
 * in the current context. An account group id may still be passed
 * to the constructor.
 */
export default class UndefinedAccountGroup extends AccountGroup {
	getName() {
		return _("Undefined account group ({id})", {
			id: this._id,
		});
	}

	accept(visitor) {
		return visitor.visitUndefinedAccountGroup(this);
	}
}
